/**
 * Normaliza opciones de un campo tipo select desde la API (lista de strings o { value, label }).
 */
export function normalizeSelectOptions(options) {
  if (!options) return [];
  if (!Array.isArray(options)) return [];
  return options.map((item) => {
    if (item && typeof item === 'object' && 'value' in item) {
      return {
        value: String(item.value),
        label: item.label != null ? String(item.label) : String(item.value),
      };
    }
    const s = String(item);
    return { value: s, label: s };
  });
}

export const PRODUCT_TYPE_OPTIONS = [
  { value: 'phone', label: 'Celular', icon: 'fas fa-mobile-alt', description: 'Smartphones nuevos o usados' },
  { value: 'tablet', label: 'Tablet', icon: 'fas fa-tablet-alt', description: 'Tablets y iPads' },
  { value: 'smartwatch', label: 'Smartwatch', icon: 'fas fa-clock', description: 'Relojes y bandas inteligentes' },
  { value: 'notebook', label: 'Notebook / PC', icon: 'fas fa-laptop', description: 'Computadoras y portatiles' },
  { value: 'headphones', label: 'Auriculares', icon: 'fas fa-headphones', description: 'TWS, vincha y cableados' },
  { value: 'speaker', label: 'Parlante', icon: 'fas fa-volume-up', description: 'Audio portatil y de escritorio' },
  { value: 'charger', label: 'Cargador', icon: 'fas fa-plug', description: 'Pared, auto e inalambricos' },
  { value: 'cable', label: 'Cable / Adaptador', icon: 'fas fa-link', description: 'Carga, datos y video' },
  { value: 'case', label: 'Funda', icon: 'fas fa-shield-alt', description: 'Proteccion para celulares' },
  { value: 'screen_protector', label: 'Vidrio / Protector', icon: 'fas fa-border-style', description: 'Vidrios, hidrogel y camara' },
  { value: 'power_bank', label: 'Power bank', icon: 'fas fa-battery-full', description: 'Baterias externas' },
  { value: 'storage', label: 'Memoria', icon: 'fas fa-save', description: 'microSD, pendrives y discos' },
  { value: 'gaming', label: 'Gaming', icon: 'fas fa-gamepad', description: 'Controles y accesorios gaming' },
  { value: 'smart_home', label: 'Smart home', icon: 'fas fa-home', description: 'Casa inteligente y redes' },
  { value: 'accessory', label: 'Accesorio general', icon: 'fas fa-puzzle-piece', description: 'Otros articulos tecnologicos' },
  { value: 'repair', label: 'Reparacion', icon: 'fas fa-tools', description: 'Servicios y repuestos' },
];

const ATTRIBUTE_UI = {
  screen_size: { icon: 'fas fa-expand', group: 'Pantalla' },
  processor: { icon: 'fas fa-microchip', group: 'Rendimiento' },
  ram: { icon: 'fas fa-memory', group: 'Rendimiento' },
  storage: { icon: 'fas fa-hdd', group: 'Rendimiento' },
  main_camera: { icon: 'fas fa-camera', group: 'Camara' },
  front_camera: { icon: 'fas fa-camera-retro', group: 'Camara' },
  battery: { icon: 'fas fa-battery-full', group: 'Energia' },
  battery_life: { icon: 'fas fa-battery-three-quarters', group: 'Energia' },
  charging_power: { icon: 'fas fa-bolt', group: 'Energia' },
  power_output: { icon: 'fas fa-bolt', group: 'Energia' },
  capacity_mah: { icon: 'fas fa-battery-full', group: 'Energia' },
  max_power: { icon: 'fas fa-bolt', group: 'Energia' },
  fast_charge: { icon: 'fas fa-bolt', group: 'Energia' },
  wireless_charging: { icon: 'fas fa-wifi', group: 'Energia' },
  included_cable: { icon: 'fas fa-link', group: 'Energia' },
  bluetooth: { icon: 'fab fa-bluetooth-b', group: 'Conectividad' },
  wifi: { icon: 'fas fa-wifi', group: 'Conectividad' },
  nfc: { icon: 'fas fa-credit-card', group: 'Conectividad' },
  sim: { icon: 'fas fa-sim-card', group: 'Conectividad' },
  network: { icon: 'fas fa-signal', group: 'Conectividad' },
  connectivity: { icon: 'fas fa-wifi', group: 'Conectividad' },
  connection_type: { icon: 'fas fa-link', group: 'Conectividad' },
  connector: { icon: 'fas fa-plug', group: 'Conectividad' },
  ports: { icon: 'fas fa-ethernet', group: 'Conectividad' },
  protocols: { icon: 'fas fa-bolt', group: 'Conectividad' },
  os: { icon: 'fas fa-mobile-alt', group: 'Software' },
  compatibility: { icon: 'fas fa-check-circle', group: 'Compatibilidad' },
  compatible_model: { icon: 'fas fa-mobile-alt', group: 'Compatibilidad' },
  platform: { icon: 'fas fa-gamepad', group: 'Compatibilidad' },
  dimensions: { icon: 'fas fa-ruler-combined', group: 'Fisico' },
  weight_device: { icon: 'fas fa-weight', group: 'Fisico' },
  material: { icon: 'fas fa-layer-group', group: 'Fisico' },
  color: { icon: 'fas fa-palette', group: 'Fisico' },
  water_resistance: { icon: 'fas fa-tint', group: 'Durabilidad' },
  noise_cancellation: { icon: 'fas fa-volume-mute', group: 'Audio' },
  microphone: { icon: 'fas fa-microphone', group: 'Audio' },
  headphone_type: { icon: 'fas fa-headphones', group: 'Audio' },
  protector_type: { icon: 'fas fa-shield-alt', group: 'Proteccion' },
  hardness: { icon: 'fas fa-gem', group: 'Proteccion' },
  coverage: { icon: 'fas fa-border-all', group: 'Proteccion' },
  finish: { icon: 'fas fa-adjust', group: 'Proteccion' },
  case_type: { icon: 'fas fa-shield-alt', group: 'Proteccion' },
  magsafe: { icon: 'fas fa-magnet', group: 'Proteccion' },
  storage_type: { icon: 'fas fa-save', group: 'Almacenamiento' },
  speed_class: { icon: 'fas fa-tachometer-alt', group: 'Almacenamiento' },
  gps: { icon: 'fas fa-location-arrow', group: 'Sensores' },
  stylus_support: { icon: 'fas fa-pen', group: 'Uso' },
  strap_size: { icon: 'fas fa-ruler-horizontal', group: 'Fisico' },
  length_cable: { icon: 'fas fa-ruler-horizontal', group: 'Fisico' },
  data_transfer: { icon: 'fas fa-exchange-alt', group: 'Conectividad' },
  gpu: { icon: 'fas fa-tv', group: 'Rendimiento' },
  rgb: { icon: 'fas fa-lightbulb', group: 'Diseno' },
  power_source: { icon: 'fas fa-plug', group: 'Energia' },
  device_type: { icon: 'fas fa-home', group: 'General' },
  service_type: { icon: 'fas fa-tools', group: 'Servicio' },
  estimated_time: { icon: 'fas fa-hourglass-half', group: 'Servicio' },
  warranty: { icon: 'fas fa-award', group: 'Servicio' },
  includes_parts: { icon: 'fas fa-cogs', group: 'Servicio' },
};

export function getProductTypeOption(value) {
  return PRODUCT_TYPE_OPTIONS.find((item) => item.value === value) || PRODUCT_TYPE_OPTIONS.find((item) => item.value === 'accessory');
}

export function getAttributeUi(key) {
  return ATTRIBUTE_UI[key] || { icon: 'fas fa-info-circle', group: 'General' };
}

export function formatAttributeValue(def, raw) {
  if (raw === null || raw === undefined || raw === '') return '—';
  if (!def) return String(raw);
  switch (def.data_type) {
    case 'boolean':
      return raw === true || raw === 'true' || raw === 1 || raw === '1' ? 'Sí' : 'No';
    case 'number':
      return typeof raw === 'number' ? String(raw) : String(raw);
    default:
      return String(raw);
  }
}

function humanizeKey(key) {
  const s = String(key).replace(/_/g, ' ');
  return s.replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * Convierte atributos del producto + definiciones en filas listas para UI.
 *
 * @param {{ attributes?: Record<string, unknown> } | null} product
 * @param {Array<Record<string, unknown>>} definitions
 * @returns {{
 *   highlights: Array<{ key: string, label: string, value: string, order: number }>,
 *   allRows: Array<{ key: string, label: string, value: string, order: number, isHighlight: boolean }>
 * }}
 */
export function mapAttributesToDisplay(product, definitions) {
  const attributes =
    product?.attributes && typeof product.attributes === 'object' && !Array.isArray(product.attributes)
      ? product.attributes
      : {};

  const defs = Array.isArray(definitions)
    ? [...definitions].sort((a, b) => {
        const oa = Number(a.order ?? 0);
        const ob = Number(b.order ?? 0);
        if (oa !== ob) return oa - ob;
        return String(a.key ?? '').localeCompare(String(b.key ?? ''));
      })
    : [];

  /** @type {Array<{ key: string, label: string, value: string, order: number, isHighlight: boolean }>} */
  const allRows = [];

  for (const def of defs) {
    if (!def?.key) continue;
    if (!(def.key in attributes)) continue;
    const raw = attributes[def.key];
    if (raw === null || raw === undefined || raw === '') continue;
    const value = formatAttributeValue(def, raw);
    if (value === '—') continue;
    allRows.push({
      key: def.key,
      label: def.label || def.key,
      value,
      order: Number(def.order ?? 0),
      isHighlight: !!def.is_highlight,
      ...getAttributeUi(def.key),
    });
  }

  for (const key of Object.keys(attributes)) {
    if (defs.some((d) => d.key === key)) continue;
    const v = attributes[key];
    if (v === null || v === undefined || v === '') continue;
    allRows.push({
      key,
      label: humanizeKey(key),
      value: String(v),
      order: 999,
      isHighlight: false,
      ...getAttributeUi(key),
    });
  }

  allRows.sort((a, b) => a.order - b.order || a.label.localeCompare(b.label));

  const marked = allRows.filter((r) => r.isHighlight);
  const highlights = (marked.length ? marked : allRows).slice(0, 5);

  return { highlights, allRows };
}
